import type { Locale } from "~/types/locale";

/**
 * [GF-94] Svea cancels an unpaid checkout after 48 h, and Norce's Svea adapter
 * hands it back while it keys orders on the basket (cart reference). Drop just before.
 */
export const STALE_SVEA_BASKET_MS = 47 * 60 * 60 * 1000;

/** Whether any checkout on this locale can mount the Svea adapter. */
export const usesSveaCheckout = (
	locale: Locale | undefined,
	fallbackAdapter?: string
): boolean => {
	const channelAdapters = Object.values(locale?.checkoutChannels ?? {}).flatMap(
		(entry) =>
			typeof entry === "object"
				? [...(entry.paymentAdapters ?? []), entry.defaultPaymentAdapter]
				: []
	);
	return [
		locale?.paymentAdapter ?? fallbackAdapter,
		...(locale?.paymentAdapters ?? []),
		...channelAdapters
	].some((adapter) => adapter?.toLowerCase() === "svea");
};

/** A basket that has been to checkout, with its Svea checkout started (ms) longer ago than the cutoff. */
export const isStaleCheckoutBasket = (
	startedAt: number | undefined,
	orderReference: string | null | undefined,
	now = Date.now()
): boolean => {
	if (!orderReference || startedAt === undefined) return false;
	return Number.isFinite(startedAt) && now - startedAt > STALE_SVEA_BASKET_MS;
};
